module.exports = __webpack_public_path__ + "media/images/icon__arrow-right-0c8597e87a9fa41a19583dbf4865ea26.png";